/* eslint-disable no-unused-vars */
import React from 'react';
import { useSelector } from 'react-redux';

import GetSellerConfig from './GetSellerConfig';

const DividerAccent = () => {
    
    const { 
        seller, sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
    } = GetSellerConfig();

    return (
        <div>
            {/* Animated divider */}
            <div className="relative flex items-center gap-3 w-48">
                <div
                    className="h-[2px] flex-1 origin-right"
                    style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixMedium }} />
                <div
                    className="w-3 h-3 rounded-full flex-shrink-0"
                    style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }} />
                <div
                    className="h-[2px] flex-1 origin-left"
                    style={{ backgroundColor: sellerPrimaryColor1  + sellerColorSuffixMedium}} />
            </div>            
        </div>
    );
};

export default DividerAccent;
